import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useGlyphLookup } from './useGlyphLookup';
import GlyphSelector from './GlyphSelector';
import GlyphInfoCard from './GlyphInfoCard';
import WordsTable from './WordsTable';
import EmptyState from '../../../../components/common/EmptyState';

const GlyphLookupTab = () => {
  const theme = useTheme();
  const {
    selectedGlyph,
    loading,
    error,
    page,
    rowsPerPage,
    audioPlaying,
    totalWords,
    availableGlyphs,
    handleGlyphChange,
    handleChangePage,
    handleChangeRowsPerPage,
    handlePlayAudio,
    hasSelection,
    hasWords,
    displayedWords
  } = useGlyphLookup();

  const renderContent = () => {
    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
          <CircularProgress />
        </Box>
      );
    }

    if (!hasSelection) {
      return <EmptyState />;
    }

    if (hasWords) {
      return (
        <Box className="card-fade-in">
          <GlyphInfoCard
            selectedGlyph={selectedGlyph}
            totalWords={totalWords}
            audioPlaying={audioPlaying}
            onPlayAudio={handlePlayAudio}
          />
          <WordsTable
            displayedWords={displayedWords}
            totalWords={totalWords}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            selectedGlyph={selectedGlyph}
          />
        </Box>
      );
    }

    return <EmptyState />;
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Glyph Lookup
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Select a glyph to view words that use it and learn more about its pronunciation.
      </Typography>

      <GlyphSelector
        selectedGlyph={selectedGlyph}
        availableGlyphs={availableGlyphs}
        onChange={handleGlyphChange}
      />

      {error && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 3, 
            bgcolor: alpha(theme.palette.error.main, 0.1),
            color: theme.palette.error.main
          }}
        >
          {error}
        </Alert>
      )}

      {renderContent()}
    </Box>
  );
};

export default GlyphLookupTab;